export const SET_DATA = "@APIKEYS/SET_DATA";
export const SET_FORMATTED = "@APIKEYS/SET_FORMATTED";
export const READ = "@APIKEYS/READ";
export const READ_FAIL = "@APIKEYS/READ_FAIL";
export const READ_SUCCESS = "@APIKEYS/READ_SUCCESS";
export const REQUEST_READ = "@APIKEYS/REQUEST_READ";
